import Vue from "vue";
import VueRouter from "vue-router";
import { public_routes } from "./public-routes";
import { customer_routes } from "./customer-routes";
import { partner_routes } from "./partner-routes";

Vue.use(VueRouter);
import beforeEach from "./beforeEach";

const routes = [...public_routes, ...customer_routes, ...partner_routes];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(beforeEach);

export default router;
